import HttpHelper from '../helpers/HttpHelper.js';

export default {
  SentRequest: (form) => {
    return HttpHelper.PostJSON(
      'https://b2b.redcom.ru/bitrix/templates/b2b-redcom/ajax.php',
      {
        form_name: "connect",
        action: "submit_email_form",
        name: form.fields.name,
        phone: form.fields.phone,
        company_name: form.fields.company,
        address: form.fields.address,
        internet: form.services.internet,
        telephony: form.services.telephony,
        wi_fi: form.services.wifi,
        sip: form.services.sip,
        atc: form.services.ats,
        virtual_network: form.services.virtual_network,
        tv: form.services.false,
        other: form.services.false,
        call_time: form.preferredTime
      }
    );
  }
}
